export let TourCompletionStatus;
(function (TourCompletionStatus) {
  TourCompletionStatus["COMPLETE"] = "COMPLETE";
  TourCompletionStatus["INCOMPLETE"] = "INCOMPLETE";
  TourCompletionStatus["SKIPPED"] = "SKIPPED";
})(TourCompletionStatus || (TourCompletionStatus = {}));